const downloadBinaryReport = async (filename: string, report: string) => {
    const binaryString = atob(report);

    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob(
        [bytes],
        {
            type: 'text/csv;charset=utf-8'
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    link.remove();

    URL.revokeObjectURL(url);
}

export {
    downloadBinaryReport
}